<div #quickaction class="quickaction">
  <div class="body">
    <div *ngFor="let action of actions">
      <button (click)="actionClicked(action)" class="button">{{ action.text }}</button>
    </div>
  </div>
</div>
<div #arrow class="arrow-{{ getArrowClass() }}"></div>
